import { PICKUP_LABEL } from '../constants/delivery';

/** Delivery address of an order as text; a self-pickup order has no address. */
export function orderAddressText(order: any): string {
    if (order?.pickup) {
        return PICKUP_LABEL;
    }
    return [order?.town, order?.district, order?.unit, order?.street].filter(Boolean).join(', ');
}
